import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { appPaths } from '~/routes/app-paths';

import * as S from './EmptyState.styles';

interface EmptyStateProps {
  onCloseDropdown: () => void;
}

export const EmptyState = ({ onCloseDropdown }: EmptyStateProps) => {
  const { t } = useTranslation('alerts');
  const navigate = useNavigate();

  return (
    <S.Root>
      <img
        src="/app/static/images/empty-state/radio-telescope.png"
        width={160}
        height={160}
        alt=""
      />
      <S.TextWrapper>
        <S.Title>{t('alerts:emptyState.title')}</S.Title>
        <S.ViewPastNotificationsButton
          onClick={() => {
            navigate(appPaths.alerts);
            onCloseDropdown();
          }}
        >
          {t('alerts:emptyState.viewPastNotifications')}
        </S.ViewPastNotificationsButton>
      </S.TextWrapper>
    </S.Root>
  );
};
